import { Navigate } from 'react-router-dom'
import LocalStorage from '../Services/LocalStorage'

const ProtectedRoute = ({ children }) => {
  const jwt = LocalStorage.get('jwt')
  const user = LocalStorage.get('user')

  // Se non c'è token o user, reindirizza al login
  if (!jwt || !user) {
    return <Navigate to='/' replace />
  }

  return children
}

export default ProtectedRoute
